'use client';

import React, { useEffect, useState } from 'react';
import styles from './ScrollProgress.module.css';

/**
 * ScrollProgress Component
 * Shows a progress bar indicating how far the user has scrolled down the page
 */
export function ScrollProgress() {
  const [scrollProgress, setScrollProgress] = useState(0);

  useEffect(() => {
    const updateScrollProgress = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY;

      // Calculate scroll percentage
      const scrollableHeight = documentHeight - windowHeight;
      const progress = scrollableHeight > 0 ? (scrollTop / scrollableHeight) * 100 : 0;

      setScrollProgress(Math.min(progress, 100));
    };

    // Initial calculation
    updateScrollProgress();

    // Update on scroll
    window.addEventListener('scroll', updateScrollProgress, { passive: true });
    
    // Update on resize (in case content changes)
    window.addEventListener('resize', updateScrollProgress, { passive: true });

    return () => {
      window.removeEventListener('scroll', updateScrollProgress);
      window.removeEventListener('resize', updateScrollProgress);
    };
  }, []);

  return (
    <div className={styles.scrollProgressContainer}>
      <div 
        className={styles.scrollProgressBar}
        style={{ width: `${scrollProgress}%` }}
      />
    </div>
  );
}

